import { css } from 'aphrodite/no-important';
import map from 'lodash/map';
import { IGenericObject } from 'models';
import React, { FC } from 'react';
import { style } from './style';

interface Props {
  title: string;
  abstract: string;
  speakerDetails: IGenericObject[];
  cmsData: IGenericObject;
}
export const Abstract: FC<Props> = ({ title, abstract, speakerDetails, cmsData }) => {
  const speakerNames = map(speakerDetails, 'name').join('/');
  const companyNames = map(speakerDetails, 'company').join('/');
  const styles = style({});

  const renderSpeakers = () => {
    return speakerDetails.map((speaker, index) => {
      return (
        <React.Fragment key={index}>
          <div>
            <div className={css(styles.speakerInfoContainer)}>
              {speaker.image_url && (
                <div className={css(styles.speakerImageContainer)}>
                  <img src={speaker.image_url} alt={`${speaker.name}`} />
                </div>
              )}
              <div className={css(styles.speakerIdentityInfo)}>
                <span className={css(styles.speakerName)}>{speaker.name}</span>
                <span className={css(styles.speakerTitle)}>{speaker.title}</span>
                <span className={css(styles.speakerCompany)}>{speaker.company}</span>
                <div className={css(styles.speakerExperienceContainer, styles.experienceTablet)}>
                  <span className={css(styles.experienceLabel)}>{cmsData.experience}:</span>
                  <div dangerouslySetInnerHTML={{ __html: speaker.experience }}></div>
                </div>
              </div>
            </div>
            <div className={css(styles.speakerExperienceContainer, styles.experienceMobile)}>
              <span className={css(styles.experienceLabel)}>{cmsData.experience}:</span>
              <div dangerouslySetInnerHTML={{ __html: speaker.experience }}></div>
            </div>
          </div>
          {index < speakerDetails.length - 1 && <hr className={css(styles.speakerDivider)} />}
        </React.Fragment>
      );
    });
  };
  return (
    <div className={css(styles.container)}>
      <h1 className={css(styles.title)}>{title}</h1>
      <span className={css(styles.speakerNames)}>{speakerNames}</span>
      <span className={css(styles.speakerCompanies)}>{companyNames}</span>
      <div dangerouslySetInnerHTML={{ __html: abstract }}></div>
      <hr className={css(styles.abstractDivider)} />

      <section>
        <h2>{cmsData.speakers}</h2>
        {renderSpeakers()}
      </section>
    </div>
  );
};
